// El evento se conserva desde el arranque, aunque el menú aún no esté montado.
export function createManagerInstallation(browserWindow, onChange) {
    const displayMode = browserWindow.matchMedia(
        '(display-mode: standalone), (display-mode: minimal-ui), (display-mode: window-controls-overlay)',
    );
    let deferredPrompt = null;
    let installed = false;
    const installation = { canInstall: false, install, dispose };

    function isStandalone() {
        return (
            displayMode.matches || browserWindow.navigator.standalone === true
        );
    }

    function updateAvailability() {
        installation.canInstall =
            !!deferredPrompt && !installed && !isStandalone();
        onChange();
    }

    function onBeforeInstallPrompt(event) {
        if (installed || isStandalone()) return;
        event.preventDefault();
        deferredPrompt = event;
        updateAvailability();
    }

    function onAppInstalled() {
        installed = true;
        deferredPrompt = null;
        updateAvailability();
    }

    async function install() {
        if (!installation.canInstall) return;
        const prompt = deferredPrompt;
        // Cada evento se puede usar una sola vez, incluso si se cancela el diálogo.
        deferredPrompt = null;
        updateAvailability();
        try {
            // Invocar antes del primer await conserva la activación del clic.
            await prompt.prompt();
            const choice = await prompt.userChoice;
            if (choice.outcome === 'accepted') installed = true;
        } finally {
            updateAvailability();
        }
    }

    browserWindow.addEventListener(
        'beforeinstallprompt',
        onBeforeInstallPrompt,
    );
    browserWindow.addEventListener('appinstalled', onAppInstalled);
    displayMode.addEventListener('change', updateAvailability);

    function dispose() {
        browserWindow.removeEventListener(
            'beforeinstallprompt',
            onBeforeInstallPrompt,
        );
        browserWindow.removeEventListener('appinstalled', onAppInstalled);
        displayMode.removeEventListener('change', updateAvailability);
    }

    return installation;
}
